export const BigCloudIcon = (): JSX.Element => (
  <svg width="236" height="128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M171.472 94.704C161.361 112.858 142.959 125 121.935 125c-21.553 0-40.35-12.761-50.284-31.68-5.107 3.656-11.435 5.818-18.287 5.818-13.842 0-25.544-8.825-29.37-20.95-1.649.41-3.391.63-5.192.63C8.418 78.817 0 71.511 0 62.5s8.418-16.318 18.802-16.318c4.458 0 8.554 1.347 11.777 3.597 5.617-5.99 13.745-9.754 22.785-9.754.208 0 .415.002.622.006 1.483-8.453 7.574-14.785 14.862-14.785 2.036 0 3.979.494 5.754 1.39C85.055 10.53 102.358 0 121.935 0c21.253 0 39.825 12.408 49.863 30.89a50.85 50.85 0 0 1 3.225-.102c10.913 0 20.808 3.483 28.037 9.132 3.328-1.119 7.038-1.743 10.949-1.743 14.355 0 25.991 8.409 25.991 18.78 0 10.373-11.636 18.782-25.991 18.782a36.41 36.41 0 0 1-2.259-.07c-6.202 11.28-20.313 19.159-36.727 19.159-1.197 0-2.381-.042-3.551-.124Z"
      fill="#DFF0FC"
      fillOpacity=".5"
    />
  </svg>
);
